import React from "react";
import CommunityViewPage from "../community/components/CommunityViewPage";
import { ASK_FOR_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function ViewAskForHelpPage() {
  useRequireSectionVisible("showAskForHelp");
  return <CommunityViewPage section={ASK_FOR_HELP} />;
}
